export default __webpack_public_path__ + "static/media/empty.29cffea3.png";